import {UserGender} from "../../users/model/User";

export class BranchUsers {
    firstName: string;
    lastName: string;
    position: string;
    email: string;
    avatarUrl: string;
    gender: UserGender;
}